export const ACTION_LOCATION = 'properties-module';
